export default "__VITE_ASSET__BCEQN0fW__"